{
  "You're invited to watch {title}": "Convidamos você para assistir a {title}",
  "Share your event link": "Compartilhe o link do seu evento",
  "device|desktop": "computador",
  "device|phone": "celular",
  "device|tablet": "tablet",
  "device|tv": "TV",
  "device|console": "console",
  "{hours}h {minutes}m": "{hours} h {minutes} min",
  "Sorry, there's been an error loading the analytics data.": "Desculpe, ocorreu um erro ao carregar as estatísticas.",
  "Detailed analytics are available for events starting May 20, 2025. Below are the basic statistics for this event.": "As estatísticas detalhadas estão disponíveis para eventos a partir de 20 de maio de 2025. Abaixo estão as estatísticas básicas deste evento.",
  "Viewed Live": "Assistiram ao vivo",
  "Watched Replay": "Assistiram à gravação",
  "Powered by": "Com tecnologia de",
  "{count} views": {
    "one": "{count} visualização",
    "other": "{count} visualizações"
  },
  "{count} viewers": {
    "one": "{count} espectador",
    "other": "{count} espectadores"
  },
  "Analytics are kept for 100 days. Export a PDF to keep a copy.": "As estatísticas ficam guardadas por 100 dias. Exporte um PDF para guardar uma cópia.",
  "Total Views": "Total de visualizações",
  "Unique Viewers": "Espectadores únicos",
  "Total Watch Time": "Tempo total assistido",
  "Views": "Visualizações",
  "Watch Time": "Tempo assistido",
  "Top Countries": "Principais países",
  "Top Regions / States": "Principais regiões / estados",
  "analytics|Unknown": "Desconhecido",
  "Device Categories": "Tipos de dispositivo",
  "Top Browsers": "Principais navegadores",
  "Operating Systems": "Sistemas operacionais",
  "Import": "Importar",
  "Invite a guest": "Convidar uma pessoa",
  "We'll email them the event link and remind them before you go live.": "Enviaremos o link do evento por e-mail e um lembrete antes de você transmitir ao vivo.",
  "CSV Import": "Importar CSV",
  "Select File": "Selecionar arquivo",
  "Format: CSV. Required column: Email. Optional columns: Name, First Name, Last Name": "Formato: CSV. Coluna obrigatória: “Email”. Colunas opcionais: “Name”, “First Name”, “Last Name” (em inglês)",
  "Invite All ({count})": "Convidar todos ({count})",
  "Couldn't load the guest list": "Não foi possível carregar a lista de convidados",
  "Remove the guest from the list?": "Remover este convidado da lista?",
  "guest status|Joined Live": "Assistiu ao vivo",
  "guest status|Watched Replay": "Assistiu à gravação",
  "guest status|Visited page": "Visitou a página",
  "guest status|Invited": "Convite enviado",
  "{count} guest": {
    "one": "{count} convidado",
    "other": "{count} convidados"
  },
  "Open the guest list": "Abrir a lista de convidados",
  "Guests of every {noun} are on the guest list of {label} (the main link). They sign up once and can watch every {noun}.": "Os convidados de cada {noun} ficam na lista de convidados de {label} (o link principal). Eles se inscrevem uma vez e podem assistir a qualquer {noun}.",
  "Start inviting guests": "Comece a convidar",
  "Invite guests by email or just share your event link with them.": "Convide por e-mail ou simplesmente compartilhe o link do seu evento.",
  "Guests who sign the guestbook or ask for reminders appear here too.": "Os convidados que assinam o livro de visitas ou pedem lembretes também aparecem aqui.",
  "Share link": "Compartilhar link",
  "Download guest list": "Baixar lista de convidados",
  "Guests {title}.csv": "Convidados {title}.csv",
  "Guests.csv": "Convidados.csv",
  "{title}-report.pdf": "{title}-relatorio.pdf",
  "analytics-report.pdf": "relatorio-de-estatisticas.pdf",
  "Export PDF": "Exportar PDF",
  "Invitation sent": "Convite enviado",
  "{name} will get reminders before you go live.": "{name} vai receber lembretes antes de você transmitir ao vivo.",
  "Couldn't send the invitation": "Não foi possível enviar o convite",
  "Guest's name": "Nome do convidado",
  "e.g. Maria Lopez": "Ex.: Maria Souza",
  "Send invitation": "Enviar convite",
  "Could not open image library.": "Não foi possível abrir a galeria de fotos.",
  "Delete Cover?": "Excluir a imagem de capa?",
  "Delete failed": "Não foi possível excluir",
  "Processing image...": "Processando imagem...",
  "Uploading... {percent}%": "Enviando... {percent}%",
  "Invalid file": "Arquivo inválido",
  "Only JPG or PNG files are accepted": "Só são aceitos arquivos JPG ou PNG",
  "Drop image here": "Solte a imagem aqui",
  "Drop image here or click to select": "Solte a imagem aqui ou clique para selecionar",
  "Recommended size: 1280x720 pixels": "Tamanho recomendado: 1280x720 pixels",
  "Accepts PNG or JPG under 50MB": "Aceita PNG ou JPG com menos de 50 MB",
  "Couldn't save that": "Não foi possível salvar",
  "Guests who watch on your website get emails that link back to the page they watched on.": "Os convidados que assistem no seu site recebem e-mails com links para a página em que assistiram.",
  "Pages where guests watch your embed will show up here.": "As páginas em que os convidados assistem ao seu Embed vão aparecer aqui.",
  "Seen on": "Visto em",
  "Use for email links": "Usar nos links dos e-mails",
  "Ignore": "Ignorar",
  "Used for email links": "Em uso nos links dos e-mails",
  "Stop using": "Parar de usar",
  "Other guests": "Outros convidados",
  "Your Embed webpage URL from before. Remove it to send everyone else to evt.live.": "A URL da página com seu Embed que você usava antes. Remova-a para enviar todos os outros para o evt.live.",
  "EventLive event": "Evento do EventLive",
  "How this event's page looks to guests. It overrides the branding in your profile.": "Como os convidados veem a página deste evento. Tem prioridade sobre a marca do seu perfil.",
  "Could not update branding settings": "Não foi possível atualizar as configurações de marca",
  "Event page": "Página do evento",
  "Description": "Descrição",
  "A few words for your guests": "Algumas palavras para seus convidados",
  "Supports Markdown: **bold**, lists and links.": "Aceita Markdown: **negrito**, listas e links.",
  "e.g. 7pm ET / 4pm PT": "Ex.: 20h Brasília / 23h Lisboa",
  "Replaces the date and time on your event page and in reminder emails.": "Substitui a data e a hora na página do seu evento e nos e-mails de lembrete.",
  "Company": "Empresa",
  "Shown on this event page only. PNG or JPG; it's trimmed and resized automatically. Horizontal logos work best. A white logo on a transparent background may not show on a light page.": "Aparece só na página deste evento. PNG ou JPG; ele é recortado e redimensionado automaticamente. Logotipos horizontais funcionam melhor. Um logotipo branco com fundo transparente pode não aparecer em uma página clara.",
  "Put your event page or just the video player on your own website.": "Coloque a página do seu evento ou só o player de vídeo no seu próprio site.",
  "Layout": "Layout",
  "Full embed": "Embed completo",
  "The event page: video, guestbook and reminders.": "A página do evento: vídeo, livro de visitas e lembretes.",
  "Just video": "Só o vídeo",
  "Only the video player.": "Só o player de vídeo.",
  "These change the code below. Copy it again after changing them.": "Estas opções alteram o código abaixo. Copie o código de novo depois de mudá-las.",
  "Autoplay": "Reprodução automática",
  "Start the video automatically.": "Inicia o vídeo automaticamente.",
  "Reminder button": "Botão de lembrete",
  "Guests can sign up for reminders from your website.": "Os convidados podem pedir lembretes pelo seu site.",
  "No replay and no rewind in the embed.": "Sem gravação e sem retroceder no Embed.",
  "Script (recommended)": "Script (recomendado)",
  "Viewers who open an EventLive email link on your page are recognized there, and the player is sized to fit.": "Os espectadores que abrem na sua página um link de e-mail do EventLive são reconhecidos, e o player se ajusta ao espaço.",
  "Simple iframe (no script)": "Iframe simples (sem script)",
  "For site builders that remove scripts. The player can't see viewers' email links, so ticket holders on a new device may have to sign in again.": "Para criadores de sites que removem scripts. O player não vê os links dos e-mails dos espectadores, então quem tem ingresso pode precisar entrar de novo em um dispositivo novo.",
  "Embed code": "Código Embed",
  "Copy embed code": "Copiar código Embed",
  "Embed code copied": "Código Embed copiado",
  "Paste it into your website's HTML.": "Cole-o no HTML do seu site.",
  "Preview": "Pré-visualização",
  "Couldn't load the guestbook": "Não foi possível carregar o livro de visitas",
  "Delete this message?": "Excluir esta mensagem?",
  "Messaging": "Mensagens",
  "Chat": "Chat",
  "You pinned": "Fixada por você",
  "Delete this message": "Excluir esta mensagem",
  "Could not update messaging settings": "Não foi possível atualizar as configurações de mensagens",
  "Guests sign it and add photos. Newest messages first.": "Os convidados assinam e adicionam fotos. As mensagens mais recentes aparecem primeiro.",
  "A live chat next to the video, like a group conversation.": "Um chat ao vivo ao lado do vídeo, como uma conversa em grupo.",
  "Disable messaging": "Desativar mensagens",
  "Guests can watch but can't post messages.": "Os convidados podem assistir, mas não podem publicar mensagens.",
  "{count} message": {
    "one": "{count} mensagem",
    "other": "{count} mensagens"
  },
  "Loading messages…": "Carregando mensagens…",
  "No messages yet. They'll appear here as guests post them.": "Ainda não há mensagens. Elas vão aparecer aqui quando os convidados as publicarem.",
  "Could not update privacy settings": "Não foi possível atualizar as configurações de privacidade",
  "Hide event page": "Ocultar página do evento",
  "Manage tickets": "Gerenciar ingressos",
  "Guests need a ticket to watch. To let some guests in for free, invite them from the Guest List.": "Os convidados precisam de um ingresso para assistir. Para deixar alguns entrarem de graça, convide-os pela lista de convidados.",
  "Anyone with the link can watch": "Qualquer pessoa com o link pode assistir",
  "Share the link; no password or invitation needed.": "Compartilhe o link; não precisa de senha nem de convite.",
  "Password protected": "Protegido por senha",
  "Guests enter a password you give them.": "Os convidados digitam a senha que você passar para eles.",
  "Choose a password": "Escolha uma senha",
  "Invite only": "Somente para convidados",
  "Only the guests invited by email can join. One device per email at a time. (MUST be on the <list>Guest List</list>)": "Só podem entrar pessoas convidadas por e-mail. Um dispositivo por e-mail de cada vez. (PRECISAM estar na <list>lista de convidados</list>)",
  "Ask guests for their name and email": "Pedir nome e e-mail aos convidados",
  "Always on for invite-only events.": "Sempre ativado em eventos somente para convidados.",
  "Before they can watch. They'll appear in your Guest List.": "Antes de poderem assistir. Eles vão aparecer na sua lista de convidados.",
  "Replay and download": "Gravação e download",
  "Show download link to guests": "Mostrar o link de download aos convidados",
  "Hide viewer counter": "Ocultar contador de espectadores",
  "Your event page is hidden. People who bought tickets can't watch until you show it again.": "A página do seu evento está oculta. Quem comprou ingresso não pode assistir até você mostrá-la de novo.",
  "Your event page is hidden. Guests can't open it until you show it again.": "A página do seu evento está oculta. Os convidados não podem abri-la até você mostrá-la de novo.",
  "Show event page": "Mostrar página do evento",
  "Remove {guest} from the guest list": "Remover {guest} da lista de convidados",
  "Message pinned": "Mensagem fixada",
  "Guests see it at the top of the guestbook.": "Os convidados a veem no topo do livro de visitas.",
  "Couldn't pin the message": "Não foi possível fixar a mensagem",
  "e.g. Welcome! The ceremony starts at 3 pm.": "Ex.: Boas-vindas! A cerimônia começa às 15h.",
  "Stays at the top of the guestbook or chat.": "Fica no topo do livro de visitas ou do chat.",
  "Pin message": "Fixar mensagem",
  "Share on {network}": "Compartilhar no {network}",
  "Share on Email": "Compartilhar por e-mail",
  "Preview my Event Page": "Ver a página do meu evento",
  "Share via:": "Compartilhar via:",
  "Viewer-hours": "Horas-espectador",
  "{count} viewer-hour": {
    "one": "{count} hora-espectador",
    "other": "{count} horas-espectador"
  },
  "Live {live} · Replay {replay}": "Ao vivo {live} · Gravação {replay}",
  "Ticketed events have no viewer-hour limit.": "Eventos com ingresso não têm limite de horas-espectador.",
  "{used} of {limit} viewer-hours included with this event": "{used} de {limit} horas-espectador incluídas neste evento",
  "Over the {limit} viewer-hours included with this event by {over}.": "Ultrapassou em {over} as {limit} horas-espectador incluídas neste evento.",
  "By day (UTC)": "Por dia (UTC)",
  "Show fewer days": "Mostrar menos dias",
  "Show all {count} days": {
    "one": "Mostrar {count} dia",
    "other": "Mostrar todos os {count} dias"
  },
  "Viewer-hours are updated every hour. They show here within an hour of people watching.": "As horas-espectador são atualizadas a cada hora. Elas aparecem aqui até uma hora depois que as pessoas assistem.",
  "Counted every hour from the video our CDN delivered, on every player. Viewing before {date} isn't included. Updated {updated}.": "Contadas a cada hora a partir do vídeo que nossa CDN entregou, em todos os players. O que foi assistido antes de {date} não está incluído. Atualizado: {updated}.",
  "Counted every hour from the video our CDN delivered, on every player. Updated {updated}.": "Contadas a cada hora a partir do vídeo que nossa CDN entregou, em todos os players. Atualizado: {updated}.",
  "Live viewers": "Espectadores ao vivo",
  "Devices watching each minute of the live stream.": "Dispositivos assistindo a cada minuto da transmissão ao vivo.",
  "Live viewers per minute from {start} to {end}. Peak: {peak} at {time}.": "Espectadores ao vivo por minuto, de {start} a {end}. Pico: {peak} ({time}).",
  "Peak: {count} at {time}": "Pico: {count} ({time})",
  "{count} viewer at {time}": {
    "one": "{count} espectador ({time})",
    "other": "{count} espectadores ({time})"
  },
  "Updated every hour, for every player, and kept for good.": "Atualizadas a cada hora, em todos os players, e guardadas para sempre.",
  "Browsers and apps": "Navegadores e apps",
  "{count} viewer": {
    "one": "{count} espectador",
    "other": "{count} espectadores"
  },
  "Regions:": "Regiões:",
  "IP Geolocation by DB-IP": "Geolocalização de IP por DB-IP",
  "Before {date}": "Antes de {date}",
  "From our previous analytics, which counted browsers only, saved for good before they expired.": "Das nossas estatísticas anteriores, que contavam só navegadores, guardadas para sempre antes de expirarem.",
  "Viewers": "Espectadores",
  "{live} live · {replay} replay only": "{live} ao vivo · {replay} só a gravação",
  "{time} per viewer": "{time} por espectador",
  "Peak live viewers": "Pico de espectadores ao vivo",
  "Watch time, views, countries and devices are counted from {date}. Unique viewers are counted for every event.": "O tempo assistido, as visualizações, os países e os dispositivos são contados a partir de {date}. Os espectadores únicos são contados em todos os eventos.",
  "Viewers here are devices on each day: someone watching on two days counts twice. Counted every hour from the video our CDN delivered, on every player.": "Aqui, os espectadores são dispositivos por dia: alguém que assiste em dois dias conta duas vezes. Contados a cada hora a partir do vídeo que nossa CDN entregou, em todos os players.",
  "Mux, for comparison": "Mux, para comparação",
  "The previous report: the last 100 days, browsers that report to Mux only.": "O relatório anterior: os últimos 100 dias, apenas os navegadores que enviam dados ao Mux.",
  "analytics|Other": "Outros",
  "Analytics are updated every hour. They show here within an hour of people watching.": "As estatísticas são atualizadas a cada hora. Elas aparecem aqui até uma hora depois que as pessoas assistem.",
  "Counted from {date}; the viewing before it is further down.": "Contado a partir de {date}; o que foi assistido antes está mais abaixo.",
  "Counted from {date}; the viewing before it wasn't counted.": "Contado a partir de {date}; o que foi assistido antes não foi contado.",
  "Live viewing during {times} isn't fully counted: our video network didn't save all its logs for that time.": "As visualizações ao vivo durante {times} não foram totalmente contadas: nossa rede de vídeo não salvou todos os registros desse período.",
  "This event keeps its current report until {date}. Then it moves to our new analytics, which count every player and are kept for good. Export a PDF to keep a copy of this report.": "Este evento mantém o relatório atual até {date}. Depois, ele passa para as nossas novas estatísticas, que contam todos os players e ficam guardadas para sempre. Exporte um PDF para guardar uma cópia deste relatório."
}
